/* tslint:disable:restrict-plus-operands */
import { createSelector } from '@opengov/compose-app/reselect';

import { contextMenuSelector } from './contextMenuState';

import { contextMenuAlignment as alignment } from './constants';

export const selectContextMenuComponentType = createSelector(
  contextMenuSelector,
  contextMenuState => contextMenuState.componentType
);
export const selectContextMenuTargetElementLocationData = createSelector(
  contextMenuSelector,
  contextMenuState => contextMenuState.targetElementLocationData
);
export const selectContextMenuDimensions = createSelector(
  contextMenuSelector,
  contextMenuState => contextMenuState.contextMenuDimensions
);
export const selectContextMenuAlignment = createSelector(
  contextMenuSelector,
  contextMenuState => contextMenuState.contextMenuAlignment
);

export const selectContextMenuLocation = createSelector(
  selectContextMenuDimensions,
  selectContextMenuTargetElementLocationData,
  selectContextMenuAlignment,
  (menuDimensions, targetElementLoc, alignmentState) => {
    if (!menuDimensions || !targetElementLoc) return { x: 0, y: 0 };

    // Context menu is centered by default, and if any part of it is off screen
    // it adjusts to the left or right of the clicked element depending on what would
    // allow the context menu to be seen. If it's offscreen to both the left and
    // the right, it will be centered. - Chris Loeper

    const screenHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );

    const scrollY = window.pageYOffset;

    const offScreenBottom =
      targetElementLoc.top + targetElementLoc.height + menuDimensions.height + scrollY > screenHeight;

    const defaultX = (targetElementLoc.left + targetElementLoc.right) / 2 - menuDimensions.width / 2;
    const defaultY = targetElementLoc.top + targetElementLoc.height + scrollY;
    let calculatedX = defaultX;
    let calculatedY = defaultY;

    if (offScreenBottom) calculatedY = targetElementLoc.top - menuDimensions.height + scrollY;

    switch (alignmentState) {
      case alignment.LEFT:
        calculatedX = targetElementLoc.left;
        return { x: calculatedX, y: calculatedY };

      case alignment.RIGHT:
        calculatedX = targetElementLoc.right - menuDimensions.width;
        return { x: calculatedX, y: calculatedY };

      case alignment.TOP_RIGHT:
        calculatedX = targetElementLoc.right - targetElementLoc.width / 2;
        return { x: calculatedX, y: targetElementLoc.top - menuDimensions.height - 8 };

      case alignment.CENTER:
        return { x: defaultX, y: calculatedY };

      case alignment.AUTO:
      default:
        const offScreenRight = defaultX + menuDimensions.width > window.innerWidth;
        const offScreenLeft = defaultX < 0;

        if (offScreenRight) calculatedX = targetElementLoc.right - menuDimensions.width;
        if (offScreenLeft) calculatedX = targetElementLoc.left;

        return { x: calculatedX, y: calculatedY };
    }
  }
);
